@if (incomeTaxEntity$ | async) {
  @if(heeftOndernemingen) {
    <form [formGroup]="wuoOpbrengstenFg" class="row">
      <div class="col-7">
        <p>Opbrengsten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="financieleBatenFg" class="row">
      <div class="col-7">
        <p>Financi&euml;le baten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="buitengewoneBatenFg" class="row">
      <div class="col-7">
        <p>Buitengewone baten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    @if (heeftWuoStaking) {
      <form [formGroup]="wuoStakingswinstenFg" class="row">
        <div class="col-7">
          <p>Stakingswinsten</p>
        </div>

        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="bedrag"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
      </form>
    }

    <form [formGroup]="tussentellingenFg" class="row">
      <div class="col-7">
        <p></p>
      </div>
      <div class="col-3"></div>
      <div class="col-2">
        <snelstart-ui-number-form-control [calculate]="getTussentellingOpbrengsten()"
                                          [decimals]="0"
                                          [disabledControl]="true"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="tussentellingOpbrengsten"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </form>

    <form [formGroup]="wuoInkoopkostenFg" class="row">
      <div class="col-7">
        <p>Inkoopkosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoVerkoopkostenFg" class="row">
      <div class="col-7">
        <p>Verkoopkosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoPersoneelskostenFg" class="row">
      <div class="col-7">
        <p>Personeelskosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoHuisvestingskostenFg" class="row">
      <div class="col-7">
        <p>Huisvestingskosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoAutokostenFg" class="row">
      <div class="col-7">
        <p>Autokosten</p>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoAfschrijvingenFg" class="row">
      <div class="col-7">
        <p>Afschrijvingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoOverigekostenFg" class="row">
      <div class="col-7">
        <p>Overige kosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoFinancieleLastenFg" class="row">
      <div class="col-7">
        <p>Financi&euml;le lasten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="wuoBuitengewoneLastenFg" class="row">
      <div class="col-7">
        <p>Buitengewone lasten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bedrag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
    </form>

    <form [formGroup]="tussentellingenFg" class="row">
      <div class="col-7">
        <p></p>
      </div>
      <div class="col-3"></div>
      <div class="col-2">
        <snelstart-ui-number-form-control [calculate]="getTussentellingKosten()"
                                          [decimals]="0"
                                          [disabledControl]="true"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="tussentellingKosten"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
      </div>
    </form>

    <form [formGroup]="tussentellingenFg" class="row">
      <div class="col-7">
        @if (!heeftSamenwerkingsverband) {
          <b> Winst volgens resultatenrekening</b>
        } @else {
          <b>Winst volgens resultatenrekening samenwerkingsverband</b>
        }
      </div>
      <div class="col-3"></div>
      <div class="col-2">
        <snelstart-ui-number-form-control [calculate]="getWinstResultatenrekening()"
                                          [decimals]="0"
                                          [disabledControl]="true"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="winstResultatenrekening"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </form>
  } @else {
    <p>Er zijn geen ondernemingen gevonden.</p>
  }
}
